import Colors from 'assets/Colors';
import UIConst from 'consts/UIConst';
import React, { isValidElement } from 'react';
import { Text, TextProps } from 'react-native';
import ThemeContextView from 'states/context/views/ThemeContextView';

export default class BaseText extends ThemeContextView<TextProps> {
  constructor(props) {
    super(props);
    this.state = {
      children: this.convertChildren(props.children)
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.children !== this.props.children) {
      this.setState({ children: this.convertChildren(nextProps.children) });
      return false;
    }
    return this.props !== nextProps || this.state !== nextState;
  }

  isChildInValid = (children) => {
    return typeof children === 'object' && !isValidElement(children) && children !== null && children !== undefined;
  };

  convertChildren = (children) => {
    try {
      if (this.isChildInValid(children)) {
        if (Array.isArray(children)) {
          children = children.map((e) => {
            if (this.isChildInValid(e)) e = JSON.stringify(e);
            return e;
          });
        } else {
          children = JSON.stringify(children);
        }
      }
    } catch (err) {
      console.log('ERROR', err);
    }
    return children;
  };

  static parse = (text, values = []) => {
    let list = text.split('%s');
    let listElement = [];
    for (let i = 0; i < list.length; i += 1) {
      listElement.push(<BaseText key={i.toString()}>{list[i]}</BaseText>);
      if (values.length > i) listElement.push(<BaseText key={i.toString() + '_'}>{values[i]}</BaseText>);
    }
    return listElement;
  };

  setText = (text) => {
    this.setState({ children: text });
  };

  render() {
    const { style } = this.props;
    let { children } = this.state;
    return (
      <Text {...this.props} style={[{ fontWeight: 'normal', color: Colors.text, fontSize: UIConst.FONT_SIZE }, style]}>
        {children}
      </Text>
    );
  }
}
